import React, { useEffect, useMemo, useState } from 'react';
import ReportingPageLayout from './ReportingPageLayout';
import AttributionReport from './attribution/AttributionReport';
import useReportingPage from '../hooks/useReportingPage';

const axios = require('axios').default;

export const buildAttributionFilterGroups = (options = {}, { showEvents = true } = {}) => [
  {
    id: 'venue',
    label: 'Venue',
    filters: [{
      id: 'venue_ownership_id',
      label: 'Venue',
      type: 'checkbox',
      options: (options.venue_options || []).map((venue) => ({ value: String(venue.id), label: venue.name })),
    }],
  },
  ...(showEvents ? [{
    id: 'event',
    label: 'Event',
    filters: [{
      id: 'calendar_event_id',
      label: 'Event',
      type: 'search',
      options: (options.event_options || []).map((event) => ({ value: String(event.id), label: event.name })),
    }],
  }] : []),
  {
    id: 'product',
    label: 'Product',
    filters: [{
      id: 'product_type',
      label: 'Product type',
      type: 'checkbox',
      options: (options.product_type_options || []).map((option) => ({ value: option.value, label: option.label })),
    }],
  },
];

function ReportingMarketingAttributionPage({
  team, defaultWindowDays, trackingStartedAt, maxWindowDays, calendarEventIds,
}) {
  const {
    isMobile, sidebarOpen, setSidebarOpen,
    dateRange, setDateRange,
    filterSidebarOpen, setFilterSidebarOpen,
    activeFilters, handleFilterChange, handleRemoveFilter, handleClearAllFilters,
  } = useReportingPage('month_to_date', { defaultStart: trackingStartedAt, maxDefaultDays: 365 });
  const [filterOptions, setFilterOptions] = useState({});

  useEffect(() => {
    axios.get(`/teams/${team.id}/reporting/marketing/attribution/filter_options.json`)
      .then(({ data }) => setFilterOptions(data))
      .catch((error) => console.error('Failed to load attribution filter options', error));
  }, [team.id]);

  const filterGroups = useMemo(
    () => buildAttributionFilterGroups(filterOptions, { showEvents: !calendarEventIds?.length }),
    [filterOptions, calendarEventIds],
  );

  return (
    <ReportingPageLayout
      team={team}
      activeKey="marketing_attribution"
      title="Attribution"
      subtitle="Which channels, sources and partners drove your sales."
      dateRange={dateRange}
      setDateRange={setDateRange}
      isMobile={isMobile}
      sidebarOpen={sidebarOpen}
      setSidebarOpen={setSidebarOpen}
      filterSidebarOpen={filterSidebarOpen}
      setFilterSidebarOpen={setFilterSidebarOpen}
      activeFilters={activeFilters}
      filterGroups={filterGroups}
      handleFilterChange={handleFilterChange}
      handleRemoveFilter={handleRemoveFilter}
      handleClearAllFilters={handleClearAllFilters}
      filterTitle="Filter Attribution"
      filterSubtitle="Narrow the report by venue, event and product."
    >
      <AttributionReport
        teamId={team.id}
        dateRange={dateRange}
        filters={activeFilters}
        calendarEventIds={calendarEventIds}
        defaultWindowDays={defaultWindowDays}
        trackingStartedAt={trackingStartedAt}
        maxWindowDays={maxWindowDays}
      />
    </ReportingPageLayout>
  );
}

export default ReportingMarketingAttributionPage;
